import { getStaticSeoPage } from "./staticSeoRegistry";

const TOKEN_ROUTE_PREFIXES = [
  "/vibe-pass/check-in/",
  "/partner/vibe-pass/redeem/",
  "/go/",
  "/q/",
  "/concierge/",
];

const PRIVATE_ROUTE_PREFIXES = [
  "/admin",
  "/brand",
  "/owner",
  "/me",
  "/sales",
  "/preview",
  "/venue-report/",
  "/vibe-pass/login",
  "/vibe-pass/member",
  "/vibe-pass/wallet",
];

const PUBLIC_NOINDEX_ROUTE_PREFIXES = [
  "/app",
  "/explore",
  "/map",
  "/favourites",
  "/venue/",
  "/hotel/",
];

function matchesPrefix(pathname, prefix) {
  return pathname === prefix || pathname.startsWith(prefix.endsWith("/") ? prefix : `${prefix}/`);
}

export function classifyRouteIndexPolicy(pathname) {
  const path = String(pathname || "/").split("?")[0];

  if (TOKEN_ROUTE_PREFIXES.some((prefix) => matchesPrefix(path, prefix))) {
    return "token_noindex";
  }
  if (PRIVATE_ROUTE_PREFIXES.some((prefix) => matchesPrefix(path, prefix))) {
    return "private_noindex";
  }
  if (PUBLIC_NOINDEX_ROUTE_PREFIXES.some((prefix) => matchesPrefix(path, prefix))) {
    return "public_noindex";
  }

  const staticPage = getStaticSeoPage(path);
  if (staticPage) {
    return staticPage.indexable ? "public_indexable" : "public_noindex";
  }

  // Dynamic public entities keep their existing component-level validation.
  return "public_indexable";
}

function ensureRobotsMeta(documentRef) {
  let robots = documentRef.head.querySelector('meta[name="robots"]');
  if (!robots) {
    robots = documentRef.createElement("meta");
    robots.setAttribute("name", "robots");
    documentRef.head.appendChild(robots);
  }
  return robots;
}

export function applyNoindexDocumentPolicy(documentRef, marker = "noindex") {
  if (!documentRef?.head) return;
  const robots = ensureRobotsMeta(documentRef);
  robots.setAttribute("content", "noindex,nofollow,noarchive");
  robots.dataset.v2nIndexPolicy = marker;
  documentRef.head
    .querySelectorAll('link[rel="canonical"], meta[property="og:url"], script[type="application/ld+json"]')
    .forEach((node) => node.remove());
}

export function applyRouteIndexPolicy(documentRef, pathname) {
  if (!documentRef?.head) return;
  const policy = classifyRouteIndexPolicy(pathname);
  const robots = ensureRobotsMeta(documentRef);

  if (policy === "public_indexable") {
    if (robots.dataset.v2nIndexPolicy) {
      robots.setAttribute("content", "index,follow,max-image-preview:large");
      delete robots.dataset.v2nIndexPolicy;
    }
    return;
  }

  applyNoindexDocumentPolicy(documentRef);
}

export {
  PRIVATE_ROUTE_PREFIXES,
  PUBLIC_NOINDEX_ROUTE_PREFIXES,
  TOKEN_ROUTE_PREFIXES,
};
